import React from 'react';

import { connect } from 'react-redux';

import { reloadCompany } from 'common/actions/company';

import type { Company } from 'common/api/endpoints/companies';

export type { Company } from 'common/api/endpoints/companies';
/**
 * The company can be null if the CompanyContext does not have a provider, or the subdomain is not registered
 */
export const CompanyContext = React.createContext<Company>(null as unknown as Company);
export const CompanyUtilsContext = React.createContext<{
  reloadCompany: () => Promise<void>;
}>({
  reloadCompany: () => Promise.resolve(),
});

type ConnectProps = {
  reloadCompany: () => Promise<void>;
};

type OwnProps = {
  children: React.ReactNode;
  company: Company;
};

type Props = OwnProps & ConnectProps;

const CompanyContainer = ({ company, children, reloadCompany }: Props) => {
  return (
    <CompanyContext.Provider value={company}>
      <CompanyUtilsContext.Provider value={{ reloadCompany }}>
        {children}
      </CompanyUtilsContext.Provider>
    </CompanyContext.Provider>
  );
};

export default connect(null, {
  reloadCompany,
})(CompanyContainer) as unknown as React.FC<OwnProps>;
